export const getDiscountQuote = (totalHt, currency) => {
  let discount;

  switch (currency) {
    case 'EUR':
      discount = discountEUR(parseInt(totalHt));
      break;
    case 'PLN':
      discount = discountPLN(parseInt(totalHt));
      break;
    case 'SEK':
      discount = discountSEK(parseInt(totalHt));
      break;
    case 'DKK':
      discount = discountDKK(parseInt(totalHt));
      break;
    case 'CZK':
      discount = discountCZK(parseInt(totalHt));
      break;
    case 'HUF':
      discount = discountHUF(parseInt(totalHt));
      break;
    case 'RON':
      discount = discountRON(parseInt(totalHt));
      break;
    case 'GBP':
      discount = discountGBP(parseInt(totalHt));
      break;
    default:
      discount = 0;
      break;
  }
  return discount;
};

export const discountEUR = (amount) => {
  console.log(amount);
  if (amount >= 0 && amount <= 1499.99) {
    return 5;
  }
  if (amount >= 1500.0 && amount <= 2999.99) {
    return 7;
  }
  if (amount >= 3000.0) {
    return 10;
  }
  return 0;
};

export const discountPLN = (amount) => {
  if (amount >= 0 && amount <= 6899.99) {
    return 5;
  }
  if (amount >= 6900.0 && amount <= 13799.99) {
    return 7;
  }
  if (amount >= 13800.0) {
    return 10;
  }
  return 0;
};

export const discountSEK = (amount) => {
  if (amount >= 0 && amount <= 16799.89) {
    return 5;
  }
  if (amount >= 16800.0 && amount <= 33599.89) {
    return 7;
  }
  if (amount >= 33600.0) {
    return 10;
  }
  return 0;
};

export const discountDKK = (amount) => {
  if (amount >= 0 && amount <= 11174.93) {
    return 5;
  }
  if (amount >= 11175.0 && amount <= 22349.93) {
    return 7;
  }
  if (amount >= 22350.0) {
    return 10;
  }
  return 0;
};

export const discountCZK = (amount) => {
  if (amount >= 0 && amount <= 36899.75) {
    return 5;
  }
  if (amount >= 36900.0 && amount <= 73799.75) {
    return 7;
  }
  if (amount >= 73800.0) {
    return 10;
  }
  return 0;
};

export const discountHUF = (amount) => {
  if (amount >= 0 && amount <= 584996.1) {
    return 5;
  }
  if (amount >= 585000.0 && amount <= 1169996.1) {
    return 7;
  }
  if (amount >= 1170000.0) {
    return 10;
  }
  return 0;
};

export const discountRON = (amount) => {
  if (amount >= 0 && amount <= 7469.9) {
    return 5;
  }
  if (amount >= 7470.0 && amount <= 14899.9) {
    return 7;
  }
  if (amount >= 14900.0) {
    return 10;
  }
  return 0;
};

export const discountGBP = (amount) => {
  if (amount >= 0 && amount <= 1274.99) {
    return 5;
  }
  if (amount >= 1275.0 && amount <= 2549.99) {
    return 7;
  }
  if (amount >= 2550.0) {
    return 10;
  }
  return 0;
};
